import { PhoneUtils } from '@pbt/pbt-ui-components'

import type {
  Contact,
  ContactAddressInput,
  ContactInput,
  PreviousMedicalRecordInput,
} from '~/api/graphql/generated/types'
import { isManualContactId } from '~/utils/pmrUtils'

export interface PendingPmrSnapshot {
  hasSeenVeterinarian: string
  petParentConsent: string
  previousClinics: Partial<Contact>[]
}

function mapContactToContactInput(
  contact: Partial<Contact>,
  businessId: string,
): ContactInput {
  const address: ContactAddressInput | undefined =
    contact.address != null || contact.city != null
      ? {
          address: contact.address ?? undefined,
          suite: contact.suite ?? undefined,
          city: contact.city ?? undefined,
          state: contact.state ?? undefined,
          zip: contact.zip ?? undefined,
        }
      : undefined
  const rawPhone = contact.phone ?? undefined
  const phone = rawPhone
    ? PhoneUtils.parsePhoneNumber(rawPhone) || undefined
    : undefined
  const input: ContactInput = {
    businessId,
    name: contact.name ?? '',
    phone,
    email: contact.email ?? undefined,
    address,
    kyriosId: contact.kyriosId ?? undefined,
  }
  if (contact.id != null && !isManualContactId(contact.id)) {
    input.id = contact.id
  }
  return input
}

/**
 * Maps UI PMR snapshot to API PreviousMedicalRecordInput.
 * Omits contact.id for manual-added clinics (ids from crypto.randomUUID()).
 */
export function buildPreviousMedicalRecordInput(
  snapshot: PendingPmrSnapshot,
  businessId: string,
): PreviousMedicalRecordInput {
  const contacts = snapshot.previousClinics.map((contact) =>
    mapContactToContactInput(contact, businessId),
  )
  return {
    priorVetCareStatusId: snapshot.hasSeenVeterinarian,
    consentStatusId: snapshot.petParentConsent || undefined,
    contacts: contacts.length > 0 ? contacts : undefined,
  }
}
